module.exports = __GETREMOTE__('AISERVICES');